import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Services from './Pages/Services/Services';
import Plans from './Pages/Plans/Plans';
import Careers from './Pages/Careers/Careers';
import Contact from './Pages/Contact/Contact';
import ScrollToTop from './components/ScrollToTop';
import Training from './Pages/Training/Training';
import SolarAssessment from './Pages/SolarAssessment/SolarAssessment';

// Import the two new floating modules
import FloatingContact from './components/FloatingContact/FloatingContact';
import ThemeToggle from './components/ThemeToggle/ThemeToggle';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-container">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/training" element={<Training />} />
            <Route path="/solar-assessment" element={<SolarAssessment />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        
        {/* Global Floating Actions */}
        <FloatingContact />
        <ThemeToggle />
        <Footer />
      </div>
    </Router>
  );
}

export default App;